import { IVacanciesState } from './vacancies.interfaces';

export const VacanciesState: IVacanciesState = {
  previewSection: {
    title: 'We care for the comfort of our people',
    subtitle:
      'Prefer working in the office? Remotely? Or both? Get a chance to choose what you’re more comfortable with and come to work with Agilie.',
    link: 'https://jobs.dou.ua/companies/agilie/vacancies/',
    wraps: [
      {
        title: 'The Agilie team is a real family 😊',
        specialistIcon: '/vacancies-images/specialities/developer.png',
        specialist: 'Developer',
        type: 'textblock',
      },
      {
        imageSrc: '/vacancies-images/preview-1.png',
        imageAlt: 'Developer',
        type: 'imageblock',
      },
      {
        imageSrc: '/vacancies-images/preview-3.png',
        imageAlt: 'Designer',
        type: 'imageblock',
      },
      {
        title: 'Cool team! 💪🏼💪🏼💪🏼 ',
        specialistIcon: '/vacancies-images/specialities/designer.png',
        specialist: 'Designer',
        type: 'textblock',
      },
      {
        imageSrc: '/vacancies-images/preview-2.png',
        imageAlt: 'Manager',
        type: 'imageblock',
      },
      {
        title: 'A team with a clear vision of common goals.',
        specialistIcon: '/vacancies-images/specialities/manager.png',
        specialist: 'Manager',
        type: 'textblock',
      },
      {
        imageSrc: '/vacancies-images/preview-4.png',
        imageAlt: 'team-member',
        type: 'imageblock',
      },
      {
        imageSrc: '/vacancies-images/preview-5.png',
        imageAlt: 'teams',
        type: 'imageblock',
      },
    ],
  },
  valueSection: {
    title: 'Our values',
    subtitle:
      'We share values and turn the Agilie team into a supportive family. Let’s strive for the common goal together!',
    items: [
      {
        iconSrc: '/vacancies-images/icons/open_door_policy.png',
        title: 'Open-door policy',
        subtitle: 'Having questions/comments/concerns? Tell us whatever you have on your mind.',
      },
      {
        iconSrc: '/vacancies-images/icons/we_on_your_side.png',
        title: 'We’re on your side',
        subtitle: 'Agilie respects your individuality. We support our people and everyone feels comfortable.',
      },
      {
        iconSrc: '/vacancies-images/icons/grow_your_skill.png',
        title: 'Grow your skill',
        subtitle: 'Hate to do the same job day by day? We’ll be happy to watch you develop your competence!',
      },
      {
        iconSrc: '/vacancies-images/icons/mentoring.png',
        title: 'Mentoring',
        subtitle: 'Your team lead is there for you. Always. We also hire consultants to move forward all together.',
      },
      {
        iconSrc: '/vacancies-images/icons/we_care.png',
        title: 'We care',
        subtitle: 'We support orphanages, promote eco-friendly brand products, help animal shelters. Eager to join us?',
      },
      {
        iconSrc: '/vacancies-images/icons/teamwork.png',
        title: 'Teamwork',
        subtitle: 'Join Agilie to support each other and work toward a common goal. This is how we prosper.',
      },
    ],
  },
  vacanciesSection: {
    title: 'Current job openings',
    sort: [
      {
        title: 'View by Location',
        list: [`All`, `Dnipro`],
      },
      {
        title: 'View by Department',
        list: [`All`, 'Web'],
      },
    ],
  },
  formSection: {
    title: 'Couldn’t find the position you’re looking for?',
    subtitle:
      'Just send us a few words on <a href="mailto:hr@agilie.com">hr@agilie.com</a>, or use the subscription form to get notified as soon as a vacancy is open.',
  },
  aboutUsSection: {
    title: 'About Agilie',
    text: [
      'What is Agilie? We’re a bunch of enthusiasts who love creating cool web and mobile solutions. Our talented team members know how to deal with up-to-date technologies to deliver clients with digital products they need.',
      'We care for each person on our team cos our people are the ones who make us a successful company. Marketers, sales staff, analysts, designers, developers, testers… every person makes his or her own contribution. Our customers trust us.',
    ],
    video: [
      {
        videoSrc: 'https://d16q0jbc5swlzh.cloudfront.net/agilie_video_about_us_480.webm',
        format: 'video/webm',
      },
      {
        videoSrc: 'https://d16q0jbc5swlzh.cloudfront.net/agilie_video_about_us_480.mp4',
        format: 'video/mp4',
      },
      {
        videoSrc: 'https://d16q0jbc5swlzh.cloudfront.net/agilie_video_about_us_720.webm',
        format: 'video/webm',
      },
      {
        videoSrc: 'https://d16q0jbc5swlzh.cloudfront.net/agilie_video_about_us_720.mp4',
        format: 'video/mp4',
      },
      {
        videoSrc: 'https://d16q0jbc5swlzh.cloudfront.net/agilie_video_about_us_1080.webm',
        format: 'video/webm',
      },
      {
        videoSrc: 'https://d16q0jbc5swlzh.cloudfront.net/agilie_video_about_us_1080.mp4',
        format: 'video/mp4',
      },
      {
        videoSrc: 'https://d16q0jbc5swlzh.cloudfront.net/images/agilie_video_about_us.mp4',
        format: 'video/mp4',
      },
    ],
    videoPreviewImage: '/vacancies-images/video-preview.png',
  },
  ourSpiritSection: {
    title: 'Our Spirit',
    subtitle: 'Let’s have a good time together!',
    items: [
      {
        imageSrc: '/vacancies-images/get_better.png',
        title: 'Get better',
        text: 'Take part in our regular meetups and workshops with resident consultants.',
      },
      {
        imageSrc: '/vacancies-images/stay_agile.png',
        title: 'Stay agile',
        text: 'In office or remotely, we stick together and work as one team no matter what.',
      },
      {
        imageSrc: '/vacancies-images/have_fun.png',
        title: 'Have fun',
        text: 'We work hard, so we play hard. Love running? Join our Agilie Run Team.',
      },
    ],
  },
  benefitsSection: {
    title: 'Benefits and Perks',
    subtitle: 'Cozy working environment and cool personal development opportunities',
    items: [
      {
        iconSrc: '/vacancies-images/icons/self_development.png',
        title: 'Self-development',
        subtitle: 'Agilie staff consultants. They’ll help you get better at what you do.',
      },
      {
        iconSrc: '/vacancies-images/icons/career_support.png',
        title: 'Career support',
        subtitle: 'We’ll make your individual development plan to see your achievements.',
      },
      {
        iconSrc: '/vacancies-images/icons/goal.png',
        title: 'Precise goal setting',
        subtitle: 'Let’s clearly define your goals and achieve them hand in hand.',
      },
      {
        iconSrc: '/vacancies-images/icons/internal_meeting.png',
        title: 'Internal meetings',
        subtitle: 'Weekly gatherings are for you to share knowledge and improve your expertise.',
      },
      {
        iconSrc: '/vacancies-images/icons/training_budget.png',
        title: 'Training budget',
        subtitle: 'Want to take some professional courses? Agilie will have it partially covered for you.',
      },
      {
        iconSrc: '/vacancies-images/icons/stay_fit.png',
        title: 'Stay fit',
        subtitle: 'Join our Agilie Run Team and let’s run marathons together.',
      },
    ],
  },
  joinUsSection: {
    title: 'Join our adventure',
    subtitle:
      'As part of our mission, we are looking for people who are full of passion. We like horizontal hierarchies, clear and simple communication and that everyone has full control over their work.',
    images: [
      `/vacancies-images/carousel/slide1.png`,
      `/vacancies-images/carousel/slide2.png`,
      `/vacancies-images/carousel/slide3.png`,
      `/vacancies-images/carousel/slide4.png`,
      `/vacancies-images/carousel/slide5.png`,
      `/vacancies-images/carousel/slide6.png`,
      `/vacancies-images/carousel/slide7.png`,
      `/vacancies-images/carousel/slide8.png`,
      `/vacancies-images/carousel/slide9.png`,
      `/vacancies-images/carousel/slide10.png`,
      `/vacancies-images/carousel/slide11.png`,
      `/vacancies-images/carousel/slide12.png`,
      `/vacancies-images/carousel/slide13.png`,
      `/vacancies-images/carousel/slide14.png`,
      `/vacancies-images/carousel/slide15.png`,
      `/vacancies-images/carousel/slide16.png`,
      `/vacancies-images/carousel/slide17.png`,
      `/vacancies-images/carousel/slide18.png`,
      `/vacancies-images/carousel/slide19.png`,
      `/vacancies-images/carousel/slide20.png`,
      `/vacancies-images/carousel/slide21.png`,
      `/vacancies-images/carousel/slide22.png`,
      `/vacancies-images/carousel/slide23.png`,
      `/vacancies-images/carousel/slide24.png`,
      `/vacancies-images/carousel/slide25.png`,
      `/vacancies-images/carousel/slide26.png`,
      `/vacancies-images/carousel/slide27.png`,
    ],
  },
};
